const FETCH_ORDER_EXPIRED_REPORTS = 'fetch_orderExpiredReports';
const FETCH_ORDER_EXPIRED_REPORTS_CSV = 'fetch_orderExpiredReports_csv';
const FETCH_ORDER_EXPIRED_REPORT = 'fetch_orderExpiredReport';
const DELETE_ORDER_EXPIRED_REPORT = 'delete_orderExpiredReport';
const PERSIST_ORDER_EXPIRED_REPORT = 'persist_orderExpiredReport';
export default {
    FETCH_ORDER_EXPIRED_REPORTS,
    FETCH_ORDER_EXPIRED_REPORTS_CSV,
    FETCH_ORDER_EXPIRED_REPORT,
    DELETE_ORDER_EXPIRED_REPORT,
    PERSIST_ORDER_EXPIRED_REPORT,
};
